<template lang="html">
  <div v-if="this.show" class="box">
    <!-- <div class="title">
      <i class="material-icons left" @click="back">arrow_back</i>
      <span>{{message.Sl211}}</span>
    </div> -->
    <VuePerfectScrollbar @settings="settings" class="list">
      <div class="li" v-for="li in list" :key="li.id">
        <div class="name" :title="li.name">
          {{li.name}}
        </div>
        <div class="percent">
          <el-progress :color="color[li.state]" :percentage="li.percent"></el-progress>
        </div>
      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  computed: {
  },
  components: {
    VuePerfectScrollbar
  },
  props: {
    id: String,
    show: Boolean,
  },
  data () {
    return {
      message: {
        Sl211: this.$lang.ui.system.l211
      },
      keepFunc: 'false',
      list: [],
      color: ['#97a8be', '#007bc5'],
      settings: {
        maxScrollbarLength: 0
      }
    }
  },
  watch: {
    show: function (val) {
      if (val) {
        this.schedulelist()
        this.keepList()
      }
    }
  },
  mounted () {
  },
  methods: {
    back () {
      this.$emit('scheduleBack')
    },
    keepList () {
      clearInterval(this.keepFunc)
      if (!this.show) {
        return
      }
      this.keepFunc = setInterval(() => {
        if (this.show) {
          this.schedulelist()
        } else {
          clearInterval(this.keepFunc)
        }
      }, 5000)
    },
    schedulelist () {
      var e = {
        op: 'upload',
        with_receivers: 1
      }
      this.$api.getPkgMore(this.id, e, response => {
        this.list = []
        for (var i = 0; i < response.receivers.length; i++) {
          if (response.receivers[i].state === 1 || response.receivers[i].state === 2) {
            var state = 1
          } else {
            state = 0
          }
          var percent = Math.floor(response.receivers[i].finished_size / response.size * 1000) / 10
          this.list.push({
            name: response.receivers[i].user.name,
            percent: percent,
            state: state
          })
        }
      })
    }
  },
  beforeDestroy () {
    clearInterval(this.keepFunc)
  }
}
</script>

<style lang="css" scoped>
.box {
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  position: absolute;
  z-index: 5;
  background-color: #fff;
}
.title {
  height: 40px;
  line-height: 40px;
}
.title i {
  float: left;
}
.title span {
  float: left;
}
.left {
  margin: 8px 20px 0 5px;
  cursor: pointer;
}
.list {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.li {
  width: 100%;
  height: 30px;
}
.name, .percent {
  height: 30px;
  float: left;
}
.name {
  width: 35%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 10px;
  line-height: 30px;
}
.percent {
  padding-top: 7.5px;
  width: 65%;
}
</style>
